import { PropAsset } from './PropAsset';

// Statue - Heykel
// TODO: Replace with SVG asset
export class Statue extends PropAsset {
  readonly id = 'statue';
  readonly width = 42;
  readonly height = 72;
  readonly walkable = false;
  readonly collisionRadius = 0.6;
  readonly occludesPlayer = true;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, variant?: number): void {
    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.2)';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 2 * s, 12 * s, 6 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Pedestal - Kaide
    ctx.fillStyle = '#6a6a6a';
    ctx.fillRect(cx - 12 * s, cy - 10 * s, 24 * s, 10 * s);

    // Pedestal top
    ctx.fillStyle = '#7a7a7a';
    ctx.fillRect(cx - 10 * s, cy - 12 * s, 20 * s, 3 * s);

    // Figure base color
    const stoneColor = variant === 1 ? '#9a8a7a' : '#8a8a7a';

    // Body - Gövde
    ctx.fillStyle = stoneColor;
    ctx.beginPath();
    ctx.moveTo(cx - 6 * s, cy - 12 * s);
    ctx.lineTo(cx - 5 * s, cy - 38 * s);
    ctx.lineTo(cx + 5 * s, cy - 38 * s);
    ctx.lineTo(cx + 6 * s, cy - 12 * s);
    ctx.closePath();
    ctx.fill();

    // Head - Kafa
    ctx.beginPath();
    ctx.arc(cx, cy - 44 * s, 7 * s, 0, Math.PI * 2);
    ctx.fill();

    // Arms - Kollar
    ctx.fillRect(cx - 14 * s, cy - 34 * s, 28 * s, 4 * s);

    // Hands - Eller
    ctx.beginPath();
    ctx.arc(cx - 14 * s, cy - 32 * s, 3 * s, 0, Math.PI * 2);
    ctx.arc(cx + 14 * s, cy - 32 * s, 3 * s, 0, Math.PI * 2);
    ctx.fill();

    // Face features (simple) - Yüz özellikleri
    ctx.fillStyle = '#5a5a5a';
    ctx.beginPath();
    ctx.arc(cx - 2 * s, cy - 45 * s, 1 * s, 0, Math.PI * 2);
    ctx.arc(cx + 2 * s, cy - 45 * s, 1 * s, 0, Math.PI * 2);
    ctx.fill();

    // Weathering effect - Eskime efekti
    ctx.fillStyle = 'rgba(0,0,0,0.1)';
    ctx.beginPath();
    ctx.arc(cx + 3 * s, cy - 25 * s, 4 * s, 0, Math.PI * 2);
    ctx.fill();
  }
}
